import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  label: {
    fontWeight: "normal",
    padding: "2px 8px 0px",
    fontSize: ".75rem",
    color: "#0C0E29",
    opacity: 0.6,
  },
}));

const SelectLabel = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.label}>{children}</div>;
};

export default SelectLabel;
